import { CreditCard, FileText, Globe2, Zap } from "lucide-react"
import { Wrap } from "./ui"

const BENEFITS = [
  [CreditCard, "Sichere Zahlung", "Zertifizierte Abwicklung über Stripe mit Karte, Apple Pay und Google Pay – oder Kauf auf Rechnung."],
  [Zap, "Direkter Zugang", "Sofortige Freischaltung nach Zahlung. Ihr Konto wird automatisch angelegt, das Onboarding erfolgt per E-Mail."],
  [Globe2, "Daten in der EU", "Eingaben und Dokumente werden ausschließlich über AWS Bedrock in der EU verarbeitet – keine Weitergabe, kein KI-Training."],
  [FileText, "Kauf auf Rechnung", "Für Unternehmen und Institutionen. Nach Prüfung, zahlbar in 14 Tagen – Reverse-Charge bei gültiger USt-IdNr."],
] as const

export function Benefits() {
  return (
    <div className="bg-surface py-16 md:py-24">
      <Wrap>
        <h2 className="text-xl font-medium md:text-2xl">Ihre Vorteile mit SINUS Access</h2>
        <p className="mb-8 mt-3 max-w-[920px] text-xs text-brand-muted md:text-sm">
          Über unsere neue Plattform sind nicht nur Ihre Daten sicher – Sie erhalten auch
          unmittelbar nach Zahlungseingang Zugriff auf die von Ihnen gebuchten Lizenzen und Pakete.
        </p>
        <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-4">
          {BENEFITS.map(([Icon, title, text]) => (
            <div key={title} className="rounded-card bg-white p-5 shadow-card md:p-6">
              <span className="mb-4 flex h-10 w-10 items-center justify-center rounded-field bg-brand-tint text-brand-blue">
                <Icon className="h-5 w-5" />
              </span>
              <h3 className="text-sm font-medium md:text-base">{title}</h3>
              <p className="mt-1.5 text-xs text-brand-muted md:text-sm">{text}</p>
            </div>
          ))}
        </div>
      </Wrap>
    </div>
  )
}
